import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppShell from './AppShell';
import { AuthProvider } from './hooks/useAuth.jsx';
import ErrorBoundary from './components/common/ErrorBoundary.jsx';

// Global CSS (Tier 1) - Loaded on all pages
// These files are now in /src for proper Vite processing and HMR
import './styles/global/bootstrap_custom.css';
import './styles/global/admin_lte.css';
import './styles/global/skin-blue.css';
import './styles/global/mobiusjustice.css';
import './styles/global/admin.css';
import './styles/global/daterangepicker.css';
import './styles/global/core.css';

// SPA-specific global styles
import './styles/main.css';

// 2025 Design Token Overrides
import './styles/tokens/colors-2025.css';      // Color tokens (must load first)
import './styles/tokens/buttons-2025.css';
import './styles/tokens/typography-2025.css';
import './styles/tokens/elevation-2025.css';
import './styles/tokens/spacing-2025.css';
import './styles/tokens/bugfixes-2025.css';

// Create root element and render the app
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
